import { useSnackbar, type SnackbarKey } from 'notistack';
import { useContext } from 'react';
import { Link } from 'react-router';

import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Stack, Typography } from '@mui/material';

import { AnalyticsContext } from 'src/AnalyticsContext';

interface EmergencyAlertProps {
    id: SnackbarKey;
    message: string;
    taskId: string;
}

const EmergencyAlert = ({ id, message, taskId }: EmergencyAlertProps) => {
    const { trackEvent } = useContext(AnalyticsContext);

    const { closeSnackbar } = useSnackbar();
    const handleClickAlert = () => {
        trackEvent('emergency-alert-notification.tap');
        closeSnackbar(id);
    };

    return (
        <Stack
            component={Link}
            to={`/alerts/alert/${taskId}`}
            onClick={handleClickAlert}
            direction="row"
            sx={{
                boxSizing: 'border-box',
                width: '100%',
                py: 1.5,
                px: 2.5,
                gap: 1.5,
                alignItems: 'center',
                color: 'common.white',
                textDecoration: 'none',
                bgcolor: 'error.main',
                borderBottom: '1px solid',
                borderColor: 'error.main',
            }}
        >
            <FontAwesomeIcon icon={faExclamationTriangle} />
            <Typography
                variant="body1"
                sx={{
                    fontWeight: 'bold',
                    color: 'common.white',
                    flexGrow: 1,
                }}
            >
                {message}
            </Typography>
            <FontAwesomeIcon icon={faChevronRight} />
        </Stack>
    );
};

export default EmergencyAlert;
